<mat-form-field appearance="outline" class="full-width custom-mat-field">
    
    <mat-select [formControl]="control" multiple [compareWith]="compareFn">
        <mat-option *ngFor="let option of options" [value]="option">
            {{ option[labelKey] }}
        </mat-option>
        
    </mat-select>
    <mat-error *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        {{ errorMessage }}
    </mat-error>
</mat-form-field>